module.exports = __webpack_public_path__ + "img/peixuntongzhi.d776fa2f.png";